import { render, staticRenderFns } from "./a-button-copy.vue?vue&type=template&id=52cbb390"
import script from "./a-button-copy.vue?vue&type=script&lang=js"
export * from "./a-button-copy.vue?vue&type=script&lang=js"
import style0 from "./a-button-copy.vue?vue&type=style&index=0&id=52cbb390&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports